<!----------------- BEGIN TS ---------------------->
<script lang="ts">
import { initPopover } from "@/plugins/bootstrapSetup";
import { Bucket, QueueInteractionFunction } from "@/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { global } from "@/fetch";
@Component({})
export default class TheUrgentUploadOverlay extends Vue {
  // ---------- Props ----------

  /** A function for making urgent upload calls. */
  @Prop() queueInteraction!: QueueInteractionFunction;

  /** The current bucket the viewer is using. */
  @Prop() currentBucket!: Bucket;

  // ------- Local Vars --------

  /** The interval that is set up to check the timestamp */
  intervalId!: ReturnType<typeof setInterval>;

  /** If at least one of the videos is missing. */
  atLeastOneVideoMissing = false;

  /** If the video is marked as important (after clicking button). */
  videoMarkedAsImportant = false;
  // --------- Watchers --------

  // ------- Lifecycle ---------
  mounted(): void {
    if (this.$refs.videoMissingButton) {
      initPopover(this.$refs.videoMissingButton as Element);
    }

    // set up an interval to update the timestamp every second
    this.intervalId = setInterval(() => {
      this.checkIfVideoMissing();
    }, 500);
  }

  destroyed(): void {
    clearInterval(this.intervalId);
  }

  // --------- Methods ---------

  /** Used to continually check if the video is missing from the local state. We have to do it this way in an interval bc the property isn't reactive bc of how I implemented this originally, whoops. */
  checkIfVideoMissing() {
    this.atLeastOneVideoMissing = global.atLeastOneVideoMissing;
  }

  /** Tells the box to queue the videos for upload using the queueInteraction function */
  urgentlyFetchVideo() {
    if (this.currentBucket) {
      this.queueInteraction("play", this.currentBucket.bucket_id, false, 82);
      this.videoMarkedAsImportant = true;
    } else {
      console.error("Failed to find current bucket.");
    }
  }
}
</script>
<!----------------- END TS ------------------------>

<!----------------- BEGIN HTML -------------------->
<template lang="html">
  <div
    class="urgent-upload-overlay-container"
    ref="videoMissingButton"
    v-show="!videoMarkedAsImportant"
  >
    <button
      v-show="atLeastOneVideoMissing"
      type="button"
      class="missing-video btn btn-warning"
      @click="urgentlyFetchVideo"
      data-bs-toggle="popover"
      data-bs-trigger="hover"
      data-bs-container="#app-container"
      :data-bs-content="`Click to prioritize uploading these videos.`"
    >
      <b-icon
        class="warning"
        icon="exclamation"
        width="20px"
        height="20px"
        color="black"
      ></b-icon>
      <span class="text">Mark as urgent</span>
    </button>
  </div>
</template>
<!----------------- END HTML ---------------------->

<!----------------- BEGIN SCSS -------------------->
<style scoped lang="scss">
.urgent-upload-overlay-container {
  display: flex;
  position: absolute;
  left: 1.5vw;
  top: 1.5vw;
  z-index: 1;

  .missing-video {
    display: flex;
    align-items: center;

    .text {
      font-size: 15px;
    }
  }

  @media only screen and (max-width: 600px), screen and (max-height: 550px) {
    .missing-video {
      .text {
        font-size: 8px;
      }
    }
  }
}
</style>
<!----------------- END SCSS ---------------------->
